import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { API_BASES } from "../../config/apiConfig";
import "../events.css";

export default function EventCertificatePage() {
  var params = useParams();
  var bookingId = (params.bookingId || "").trim();
  var _e = useState("");
  var error = _e[0];
  var setError = _e[1];

  useEffect(function () {
    if (!bookingId) {
      setError("Booking id is missing.");
      return;
    }
    var root = String(API_BASES.EVENTS || "").replace(/\/+$/, "");
    var cancelled = false;
    fetch(root + "/certificate/" + encodeURIComponent(bookingId) + "/?redirect=0")
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data || {} };
        });
      })
      .then(function (result) {
        if (cancelled) return;
        var url = result.data.certificate_url || "";
        if (!result.ok || !url) {
          setError(result.data.message || "Certificate is not ready yet.");
          return;
        }
        window.location.replace(url);
      })
      .catch(function () {
        if (!cancelled) setError("Could not open the certificate.");
      });
    return function () {
      cancelled = true;
    };
  }, [bookingId]);

  return React.createElement(
    "div",
    { className: "ev-page", style: { padding: "48px 16px", maxWidth: 520, margin: "0 auto", textAlign: "center" } },
    React.createElement("h1", { style: { fontSize: 22, marginBottom: 8 } }, "Participation certificate"),
    error
      ? React.createElement(
          "div",
          null,
          React.createElement("p", null, error),
          React.createElement(Link, { to: "/events/booking?booking_id=" + encodeURIComponent(bookingId) }, "View booking")
        )
      : React.createElement("p", null, "Opening your ZEPHYR 2026 certificate…")
  );
}
